@if (data$ | async; as data) {
  @for (packet of data.packets; track packet) {
    <div class="packet">
      <div class="packet-header">
        <span class="packet-type">
          <small>[{{packet.packet_type | hex}}]</small> {{packet.packet_type | humanize:'packet_types'}}
        </span>
        @if (!excludeTimestamp && packet.parsed.timestamp) {
          <zoned-time [time]="packet.parsed.timestamp"
            [zone]="timeZone"
            format="L LTS"
            source="utc"></zoned-time>
        }
      </div>
      <app-highlight class="packet-parsed"
        [value]="packet.parsed | exclude:['timestamp'] | json"></app-highlight>
    </div>
  }
  @if (data.left_packets.length > 0) {
    <div class="load-more">
      @if (data.left_packets.length >= 20) {
        <button mat-button (click)="loadPackets(data, 20)">Show next 20</button>
      }
      <button mat-button (click)="loadPackets(data, data.left_packets.length)">
        Show left {{data.left_packets.length}}
      </button>
    </div>
  }
}
